import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';
import activitySkyTrakReducer from '../slices/activitySkytrak';
import addAboutReducer from '../slices/addAbout';
import addPlayerScore from '../slices/addPlayerScore';
import addProductConfigurableToCartReducer from '../slices/addProductConfigurableToCart';
import addProductCustomizableToCartReducer from '../slices/addProductCustomizableToCart';
import addSimpleProductToCartReducer from '../slices/addProductSimpleToCart';
import referralFriendReducer from '../slices/addReferralFriend';
import appointmentReducer from '../slices/appointment';
import challengeReducer from '../slices/challenge';
import changeEmailDataReducer from '../slices/changeEmail';
import confirmCodeReducer from '../slices/changeEmailConfirmCode';
import verifyEmailReducer from '../slices/changeEmailVerify';
import changePasswordReducer from '../slices/changePassword';
import configReducer from '../slices/config';
import downloadVideoReducer from '../slices/downloadVideo';
import dynamicHomeReducer from '../slices/dynamicContentHome';
import dynamicHomeShopReducer from '../slices/dynamicContentHomeShop';
import gameTrackingReducer from '../slices/gameTracking';
import aboutReducer from '../slices/getAbout';
import bannerCategoryReducer from '../slices/getBannerCategory';
import categoryReducer from '../slices/getCategoryById';
import techfitReducer from '../slices/getClubFitting';
import clubOfBagReducer from '../slices/getClubsOfBags';
import dataJapanReducer from '../slices/getDataForJapan';
import listBuckReducer from '../slices/getListBucks';
import listCouponReducer from '../slices/getListCoupon';
import navigationMenuReducer from '../slices/getNavigationMenu';
import playGameHoleReducer from '../slices/getPlayGameHoleData';
import playGolfConfigReducer from '../slices/getPlayGolfConfig';
import playTrackingReducer from '../slices/getPlayTrackingDetail';
import productByCategoryReducer from '../slices/getProductByCategoryId';
import productDescriptionReducer from '../slices/getProductDescription';
import productDetailReducer from '../slices/getProductDetail';
import purchaseHistoryReducer from '../slices/getPurchased';
import techPutReducer from '../slices/getPutterFitting';
import referralReducer from '../slices/getReferral';
import searchProductReducer from '../slices/getResultsSearchProduct';
import getReturnsReducer from '../slices/getReturns';
import rootCategoryReducer from '../slices/getRootCategoryId';
import sharedVideoLessonReducer from '../slices/getSharedVideoLesson';
import specialCategoriesByTagReducer from '../slices/getSpecialCategoriesByTag';
import subCategoryReducer from '../slices/getSubCategory';
import valueAddCartReducer from '../slices/getValueAddToCart';
import golftecPlusReducer from '../slices/golftecPlus';
import handicapReducer from '../slices/handicap';
import languageReducer from '../slices/language';
import lessonPlanReducer from '../slices/lessonPlan';
import listCourseReducer from '../slices/listCourse';
import listLeaderBoardReducer from '../slices/listLeaderBoard';
import configurationReducer from '../slices/loadConfiguration';
import contentDynamicReducer from '../slices/loadHomeDynamic';
import lastLessonReducer from '../slices/loadLatestLastLesson';
import lessonByIdReducer from '../slices/loadLessonById';
import lessonHistoryReducer from '../slices/loadLessonHistory';
import myBagsReducer from '../slices/myBags';
import myRoundReducer from '../slices/myRound';
import mySwingsReducer from '../slices/mySwings';
import notificationReducer from '../slices/notification';
import bayReducer from '../slices/playerScore';
import productFilterReducer from '../slices/productFilter';
import recommendedGearReducer from '../slices/recommendedGear';
import registerReducer from '../slices/register';
import removeItemInCartReducer from '../slices/removeItemInCart';
import renewalReducer from '../slices/renewal';
import renewalJapanReducer from '../slices/renewalJapan';
import resetPasswordReducer from '../slices/resetPassword';
import restoreLessonReducer from '../slices/restoreLesson';
import scheduleReducer from '../slices/schedule';
import scoreCardReducer from '../slices/scoreCard';
import shareVideoReducer from '../slices/shareVideo';
import shopReducer from '../slices/shop';
import shopGolftecPlusReducer from '../slices/shopGolftecPlus';
import shopSkytrakReducer from '../slices/shopSkytrak';
import shopSubscribeProduct from '../slices/shopSubscribeProduct';
import skyTrakReducer from '../slices/skytrak';
import statHistoryReducer from '../slices/statHistory';
import subscriptionsHistoryReducer from '../slices/subscriptionsHistory';
import supportReducer from '../slices/support';
import updatePlayerDataReducer from '../slices/updatePlayerData';
import updateQuantityMiniCartReducer from '../slices/updateQuantityMiniCart';
import userReducer from '../slices/user';
import videoLibraryReducer from '../slices/videoLibrary';
import waitingSlotModalReducer from '../slices/waitingSlotModal';

const saveSubsetBlacklistFilter = createBlacklistFilter('user', [
  'data',
  'comparePlayer',
  'creditV3',
  'credit',
]);

const rootReducer = combineReducers({
  appointment: appointmentReducer,
  config: configReducer,
  language: languageReducer,
  user: userReducer,
  challenge: challengeReducer,
  bay: bayReducer,
  addScore: addPlayerScore,
  listCourse: listCourseReducer,
  gameTracking: gameTrackingReducer,
  configuration: configurationReducer,
  listLeaderBoard: listLeaderBoardReducer,
  techfit: techfitReducer,
  about: aboutReducer,
  addAbout: addAboutReducer,
  lessonById: lessonByIdReducer,
  lastLesson: lastLessonReducer,
  history: lessonHistoryReducer,
  schedule: scheduleReducer,
  downloadVideo: downloadVideoReducer,
  shareVideo: shareVideoReducer,
  restore: restoreLessonReducer,
  register: registerReducer,
  shop: shopReducer,
  home: contentDynamicReducer,
  productByCategoryId: productByCategoryReducer,
  category: categoryReducer,
  searchProduct: searchProductReducer,
  bannerCategory: bannerCategoryReducer,
  productDetail: productDetailReducer,
  password: resetPasswordReducer,
  productSimple: addSimpleProductToCartReducer,
  productCustomizable: addProductCustomizableToCartReducer,
  productConfigurable: addProductConfigurableToCartReducer,
  rootCategory: rootCategoryReducer,
  navigationMenu: navigationMenuReducer,
  selectValueAddCart: valueAddCartReducer,
  renewal: renewalReducer,
  updateQuantity: updateQuantityMiniCartReducer,
  removeItem: removeItemInCartReducer,
  updatePlayer: updatePlayerDataReducer,
  changePass: changePasswordReducer,
  changeEmail: changeEmailDataReducer,
  verifyEmail: verifyEmailReducer,
  confirmCode: confirmCodeReducer,
  dynamicShop: dynamicHomeShopReducer,
  dynamicHome: dynamicHomeReducer,
  support: supportReducer,
  purchaseHistory: purchaseHistoryReducer,
  notification: notificationReducer,
  productDescription: productDescriptionReducer,
  listBuck: listBuckReducer,
  referral: referralReducer,
  referralFriend: referralFriendReducer,
  sharedVideo: sharedVideoLessonReducer,
  renewalJapan: renewalJapanReducer,
  recommendedGear: recommendedGearReducer,
  dataJapan: dataJapanReducer,
  listCoupon: listCouponReducer,
  waitingSlotModal: waitingSlotModalReducer,
  lessonPlan: lessonPlanReducer,
  subscriptionHistory: subscriptionsHistoryReducer,
  subCategory: subCategoryReducer,
  techPut: techPutReducer,
  myBags: myBagsReducer,
  mySwing: mySwingsReducer,
  specialCategoriesByTag: specialCategoriesByTagReducer,
  scoreCard: scoreCardReducer,
  myRound: myRoundReducer,
  playGameHole: playGameHoleReducer,
  clubOfBag: clubOfBagReducer,
  playTracking: playTrackingReducer,
  skyStrak: skyTrakReducer,
  returns: getReturnsReducer,
  statHistory: statHistoryReducer,
  activitySkytrak: activitySkyTrakReducer,
  playGolfConfig: playGolfConfigReducer,
  videoLibrary: videoLibraryReducer,
  shopSkytrak: shopSkytrakReducer,
  golftecPlus: golftecPlusReducer,
  handicap: handicapReducer,
  shopGolftecPlus: shopGolftecPlusReducer,
  subscribeProduct: shopSubscribeProduct,
  productFilter: productFilterReducer,
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['user', 'config', 'language'],
  transforms: [saveSubsetBlacklistFilter],
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
